import React, { Component } from "react";
import PropTypes from "prop-types";
import { DefinedRange, Calendar  } from 'react-date-range';
import moment from 'moment';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';
import { defaultStaticRanges } from './DefaultRanges';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dateField: {
    width: '70px',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    color: '#333',
    fontSize: '.9em'
  },
  paddtingTop: {
    padding: '.5em'
  },
  paddingTo: {
    padding: '.5em .5em .5em 1em' 
  },
  datePickerContainer: {
    display: 'flex',
  }
});

const defaultSelection = { startDate: moment().add(1, 'day').toDate(), endDate: moment().add(1, 'day').toDate(), key: 'selection' };
class DateRange extends Component {

    state = {
      startDateOpen: false,
      endDateOpen: false,
      selection: defaultSelection,
      transactionsFrom:  this.props.dateRange.transactionsFrom || moment().add(-1, 'month').startOf('month').format('DD MMM YY'),
      transactionsTo:  this.props.dateRange.transactionsTo || moment().format('DD MMM YY'),
    };

  handleClose = () => {
    this.setState({
      anchorEl: undefined,
      startDateOpen: false,
      endDateOpen: false
    });  
  }

  openStart = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      startDateOpen: true
    });  
  }
  
  openEnd = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      endDateOpen: true
    });  
  }

  handleStart = (date) => {
    if (!moment(date).isSame(this.state.transactionsFrom)) {
      this.props.setDateRange(`?dateFrom=${moment(date).unix()}&dateTo=${moment(this.state.transactionsTo).endOf('day').unix()}`);
    }

    this.setState({
      anchorEl: undefined,
      transactionsFrom: moment(date).format("DD MMM YY"),
      selection: defaultSelection,
      startDateOpen: false
    });  
  }

  handleEnd = (date) => {
    if (!moment(date).isSame(this.state.transactionsTo)) {
      this.props.setDateRange(`?dateFrom=${moment(this.state.transactionsFrom).unix()}&dateTo=${moment(date).endOf('day').unix()}`);
    }

    this.setState({
      anchorEl: undefined,
      transactionsTo: moment(date).format("DD MMM YY"),
      selection: defaultSelection,
      endDateOpen: false
    });  
  }

  handleRange = (range) => {

    if (range.selection !== this.state.selection) {
      this.props.setDateRange(`?dateFrom=${moment(range.selection.startDate).unix()}&dateTo=${moment(range.selection.endDate).endOf('day').unix()}`);
    }
    
    this.setState({
      anchorEl: undefined,
      startDateOpen: false,
      endDateOpen: false,
      selection: range.selection,
      transactionsFrom: moment(range.selection.startDate).format('DD MMM YY'),
      transactionsTo: moment(range.selection.endDate).format('DD MMM YY')
    });  
  }


  render() {
    const { classes } = this.props;

    return (
        <form className={classes.container} >
          <div className={classes.paddtingTop}> From:</div>
          <div >
            <input className={classes.dateField} tabIndex={-1} name="startDate" type="text" value={this.state.transactionsFrom} readOnly onClick={(e) => this.openStart(e)} />
          </div>

          <div className={classes.paddingTo}>To:</div>
          <div>
            <input className={classes.dateField} tabIndex={-1} name="endDate" type="text" value={this.state.transactionsTo} readOnly onClick={(e) => this.openEnd(e)} />
          </div>

          <Popover
              open={this.state.startDateOpen}
              anchorEl={this.state.anchorEl}
              onClose={this.handleClose} >
              <div className={classes.datePickerContainer}>
                <DefinedRange
                  ranges={[this.state.selection]}
                  staticRanges={defaultStaticRanges}
                  inputRanges={[]}
                  onChange={this.handleRange}
                  className={undefined}
                />
                <Calendar
                  onChange={this.handleStart}
                  date={moment(this.state.transactionsFrom, 'DD MMM YY').toDate()}
                  minDate={moment().add(-10, 'years').toDate()}
                  maxDate={moment(this.state.transactionsTo, 'DD MMM YY').toDate()}
                  className={undefined}
                  />
              </div>
              
          </Popover>

          <Popover
              open={this.state.endDateOpen}
              anchorEl={this.state.anchorEl}
              onClose={this.handleClose} >
              <div className={classes.datePickerContainer}>
                <DefinedRange
                    ranges={[this.state.selection]}
                    staticRanges={defaultStaticRanges}
                    inputRanges={[]}
                    onChange={this.handleRange}
                    className={undefined}
                  />
                <Calendar
                  onChange={this.handleEnd}
                  date={moment(this.state.transactionsTo, 'DD MMM YY').toDate()}
                  minDate={moment(this.state.transactionsFrom, 'DD MMM YY').toDate()}
                  maxDate={moment().add(1, 'months').toDate()}
                  className={undefined}
                  />
                </div>
          </Popover>
      </form>
    );
  }
}

DateRange.propTypes = {
  setDateRange: PropTypes.func.isRequired
};


export default withStyles(styles)(DateRange);



// WEBPACK FOOTER //
// ./src/components/TransactionsMenu/DateRange.js